<template>
  <div class="page">
    <div class="floating-top">
      <button class="btn btn-signin" @click="SignInButton">
        법률신문 회원 전용 OTran 가입
      </button>
      <button class="btn btn-login" @click="LoginButton">
        OTran 회원 로그인
      </button>
    </div>
    <div class="landing">
      <div class="landing-scene">
        <div class="section-first">
          <div class="landing-content-area">
            <div class="landing-content-title">
              <p>전문가를 위한</p>
              <p>맞춤형 번역</p>
            </div>
            <div class="landing-content-subtitle">
              <p>빠르고 정확한 AI 번역 서비스</p>
            </div>
            <div class="landing-content-discription">
              <p>
                OTran 서비스는 법률가를 위한 AI로 훈련된 번역 서비스입니다. 내가
                키운 AI로 훈련된 번역기로 업무효율을 몇 배 증대시키십시오.
                빠르고 정확한 AI자동 번역과 협업서비스를 활용하여 번역시간을
                획기적으로 단축시킬 수 있습니다. 사용자에 맞춰져 훈련된 AI번역은
                사용자의 용어와 스타일대로 번역결과물을 제공합니다. 훈련을
                할수록 똑똑해지는 맞춤형 AI 번역으로 시간적 여유도 즐겨보시기
                바랍니다.
              </p>
            </div>
          </div>
          <img src="img/landing/main-top.svg" class="main-top" />
        </div>
        <div class="section-second">
          <div class="landing-content-area">
            <div class="landing-content-title">
              <p>번역 의뢰에 대한 빠른 응답</p>
            </div>
            <div class="landing-content-discription">
              <p>번역은 단순한 의미의 변환 이외에도 많은 작업을 동반합니다.</p>
              <p>OTran을 통해 당신의 시간을 절약할 수 있습니다.</p>
            </div>
          </div>
          <img
            src="img/landing/main-second-disc.svg"
            class="second-image"
          />
          <img
            src="img/landing/main-second-min-1.svg"
            class="second-image-min"
          />
          <img
            src="img/landing/main-second-min-2.svg"
            class="second-image-min"
          />
          <img
            src="img/landing/main-second-min-3.svg"
            class="second-image-min"
          />
        </div>
<!--        <div class="section-third">-->
<!--          <div class="landing-content-area">-->
<!--            <div class="landing-content-title">-->
<!--              <p>차원이 다른 법률 특화 번역</p>-->
<!--            </div>-->
<!--            <div class="landing-content-subtitle">-->
<!--              <p>오랜 경험을 가진 AI 번역 회사 시스트란과 함께합니다.</p>-->
<!--            </div>-->
<!--            <div class="landing-content-discription">-->
<!--              <p><strong>법률 분야 번역</strong>은 기존 번역기로는 대체할 수 없는 용어와 문법을 가지고 있습니다.</p>-->
<!--              <p>시스트란의 번역 기술에 법률에 특화된 AI 학습을 더했습니다.</p>-->
<!--            </div>-->
<!--            <div class="landing-content-discription">-->
<!--              <p>사용자가 직접 학습시켜 사용할 수록 더욱 사용자의 전문 분야에</p>-->
<!--              <p>특화된 번역 결과를 제공합니다.</p>-->
<!--            </div>-->
<!--            <div class="landing-content-discription-min">-->
<!--              <p><strong>법률 분야 번역</strong>은 기존 번역기로는 대체할 수 없는</p>-->
<!--              <p>용어와 문법을 가지고 있습니다.</p>-->
<!--              <p>시스트란의 번역 기술에 </p>-->
<!--              <p>법률에 특화된 AI 학습을 더했습니다.</p>-->
<!--              <p>사용자가 직접 학습시켜 사용할 수록 더욱 사용자의</p>-->
<!--              <p>전문 분야에 특화된 번역 결과를 제공합니다.</p>-->
<!--            </div>-->
<!--            <img src="img/landing/otran-button-blue.svg" class="button-image" @click="gotoOtran">-->
<!--          </div>-->
<!--        </div>-->
        <div class="section-fourth">
          <div class="landing-content-area">
            <div class="landing-content-title">
              <p>사용자가 키워가는 AI 번역기</p>
            </div>
            <div class="landing-content-discription">
              <p>
                번역을 사용할수록 번역한 문장을 학습하여 더욱 적합한 번역기가
                됩니다.
              </p>
            </div>
          </div>
          <div class="landing-image-area">
            <img
              src="img/landing/main-in-training.svg"
              class="fourth-image"
            />
            <img
              src="img/landing/main-in-engine.svg"
              class="fourth-image"
            />
          </div>
        </div>
        <div class="section-fifth">
          <img src="img/landing/about-us.svg" class="about-us-image" @click="homePage"/>
          <div class="landing-content-area">
            <div class="landing-content-discription">
              <p>
                AILingGo는 도합 40년 이상의 경험이 있는 업계 전문가들이 모인
                그룹입니다.
              </p>
              <p>
                각각 자신의 전문 분야에서 얻은 경험과 정보를 통해서 사용자의
                문제를 해결합니다.
              </p>
            </div>
            <div class="landing-content-discription-min">
              <p>AILingGo는 도합 40년 이상의 경험이 있는</p>
              <p>업계 전문가들이 모인 그룹입니다.</p>
              <p>각각 자신의 전문 분야에서 얻은 경험과 정보를 통해서</p>
              <p>사용자의 문제를 해결합니다.</p>
            </div>
          </div>
          <img
            src="img/landing/about-us-team.svg"
            class="about-us-team-image"
          />
          <img
            src="img/landing/main-lawyer.svg"
            class="about-us-team-image-min"
          />
          <div class="about-us-team-text-min">변호사</div>
          <img
            src="img/landing/main-translator.svg"
            class="about-us-team-image-min"
          />
          <div class="about-us-team-text-min">법률 전문 번역가</div>
          <img
            src="img/landing/main-po.svg"
            class="about-us-team-image-min"
          />
          <div class="about-us-team-text-min">AI 데이터 전문가</div>
          <img
            src="img/landing/main-engineer.svg"
            class="about-us-team-image-min"
          />
          <div class="about-us-team-text-min">풀스택 엔지니어</div>
        </div>
        <div class="section-sixth">
          <div class="sixth-link-area">
            <div class="sixth-link-text">
              <p>
                <strong
                  >OTran 서비스를 통해 업무를 효율적으로 관리하세요.</strong
                >
              </p>
              <p>
                Ai 번역을 활용하면 더욱 빠르고 정확하면서도 전문성있는 번역
                결과를 만들고,
              </p>
              <p>
                절약한 시간만큼 당신은 시간을 더 현명하게 사용할 수 있습니다.
              </p>
            </div>
            <div class="sixth-link-text-min">
              <p><strong>OTran 서비스를 통해</strong></p>
              <p><strong>업무를 효율적으로 관리하세요.</strong></p>
              <p>Ai 번역을 활용하면 더욱 빠르고 정확하고</p>
              <p>전문성있는 번역 결과를 만들고,</p>
              <p>절약한 시간만큼 당신은 시간을</p>
              <p>더 현명하게 사용할 수 있습니다.</p>
            </div>
            <img
              src="img/landing/otran-button-goto.svg"
              class="otran-button-goto"
              @click="SignInButton"
            />
          </div>
          <div class="landing-content-area">
            <div class="landing-content-title">
              <p>안전한 데이터 관리</p>
            </div>
            <div class="landing-content-discription">
              <p>
                모든 데이터와 파일은 암호화하여 관리됩니다. 개인정보와 기밀정보
                데이터는 학습 전에 제거됩니다.
              </p>
            </div>
            <div class="landing-content-discription-min">
              <p>모든 데이터와 파일은 암호화하여 관리됩니다.</p>
              <p>개인정보와 기밀정보 데이터는 학습 전에 제거됩니다.</p>
            </div>
          </div>
          <div class="sixth-image-area">
            <div class="sixth-image">
              <p class="sixth-image-title">사용자 문서 보호</p>
              <div class="sixth-image-content">
                <p>모든 번역 과정은 안전하게</p>
                <p>보호되며, 번역에 사용된 문서는</p>
                <p>암호화하여 저장됩니다.</p>
              </div>
            </div>
            <div class="sixth-image">
              <p class="sixth-image-title">개별 학습 데이터 보호</p>
              <div class="sixth-image-content">
                <p>학습 과정에서 사용하는</p>
                <p>데이터는 별도 처리 후</p>
                <p>분리하여 학습합니다.</p>
              </div>
            </div>
            <div class="sixth-image">
              <p class="sixth-image-title">사용자 별 번역 엔진 관리</p>
              <div class="sixth-image-content">
                <p>사용 과정에서 학습한 번역</p>
                <p>모델을 포함, 다양한 번역 모델을</p>
                <p>제공하여 개별로 관리합니다.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="section-seventh">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
    }
  },
  methods: {
    SignInButton() {
      this.$router.push('/register#lawtimes')
    },
    LoginButton() {
      this.$router.push('/login')
    },
    homePage() {
      window.open('https://ailinggo.ai','_blank', )
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin title {
  font-weight: 400;
  line-height: 1.2;
  @media (max-width: 700px) {
    font-size: 1.7em;
  }
  @media (min-width: 701px) {
    font-size: 2em;
  }
}

@mixin section {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 48px 0;
  @media (max-width: 700px) {
    width: 100vw;
  }
  @media (min-width: 992px) {
    width: 80vw;
  }
}

.page {
  width: 100vw;
  height: 100vh;
  padding-top: 36px;
  padding-bottom: 64px;
  .floating-top {
    z-index: 100;
    width: 100vw;
    top: 0;
    position: fixed;
    display: flex;
    justify-content: right;
    padding: 16px;
    background-color: rgba(141, 15, 40, 0.8);
    button {
      color: #EFEFEF;
      margin: 0 12px;
    }
    .btn-signin {
      background-color: #e9b02f;
    }
    .btn-login {
      background-color: #149B7E;
      margin-right: 36px;
    }
  }
}


@media (max-width: 700px) {
  .section-first {
    flex-direction: column;
    .landing-content-area {
      min-width: 400px;
      margin-right: 0;
      .landing-content-discription {
        margin-bottom: 24px;
        p {
          font-size: 0.8em;
        }
      }
    }
    .main-top {
      max-width: 640px;
      z-index: 1;
    }
  }
  .section-second {
    .second-image {
      display: none;
    }
    .second-image-min {
      margin-top: 12px;
      width: 52vw;
      min-width: 260px;
      max-width: 680px;
    }
    .landing-content-discription {
      p {
        font-size: 0.8em;
      }
    }
  }
  .section-third {
    .landing-content-area {
      text-align: center;
      width: 90vw;
      height: 260px;
      .landing-content-subtitle p {
        font-size: 0.9em;
      }
      .landing-content-discription p {
        display: none;
      }
      .landing-content-discription-min p {
        font-size: 0.8em;
        padding: 0 12px;
        display: block;
      }
    }
    .button-image {
      display: none;
    }
  }
  .section-fourth {
    .landing-content-discription {
      p {
        font-size: 0.8em;
      }
    }
    .landing-image-area {
      flex-direction: column;
      margin: 0 auto;
      .fourth-image {
        margin-top: 24px;
        width: 40vw;
        min-width: 160px;
        max-width: 180px;
        align-self: center;
      }
    }
  }
  .section-fifth {
    .landing-content-discription p {
      display: none;
    }
    .landing-content-discription-min p {
      font-size: 0.8em;
      padding: 0 12px;
      display: block;
    }
    .about-us-team-image {
      display: none;
    }
    .about-us-team-image-min {
      width: 32vw;
      min-width: 100px;
      max-width: 144px;
      margin-top: 24px;
    }
    .about-us-team-text-min {
      margin-top: 8px;
      margin-bottom: 24px;
    }
  }
  .section-sixth {
    .landing-content-discription p {
      display: none;
    }
    .landing-content-discription-min p {
      font-size: 0.8em;
      padding: 0 12px;
      display: block;
      color: #adc8d7;
      font-weight: 600;
    }
    .sixth-link-area {
      width: 80vw;
      flex-direction: column;
      text-align: center;
      .sixth-link-text {
        display: none;
      }
      .sixth-link-text-min p {
        font-size: 0.9em;
        color: #000000;
        margin-bottom: 4px;
      }
      .otran-button-goto {
        position: relative;
        margin: 0 auto;
        top: 20px;
      }
    }
    .sixth-image-area {
      display: block;
      .sixth-image {
        margin: 0 auto;
        padding-top: 16px;
        .sixth-image-title {
          margin-top: 12px;
        }
      }
    }
  }
}
@media (min-width: 701px) {
  .section-first {
    flex-direction: row;
    .landing-content-area {
      width: 32vw;
      margin-right: 32px;
      .landing-content-discription {
        p {
          font-size: 0.8em;
        }
      }
    }
    .main-top {
      width: 66vw;
      max-width: 640px;
      z-index: 1;
    }
  }
  .section-second {
    .second-image {
      width: 72vw;
      margin-top: 36px;
      min-width: 400px;
      max-width: 880px;
    }
    .second-image-min {
      display: none;
    }
    .landing-content-discription {
      p {
        font-size: 0.8em;
      }
    }
  }
  .section-third {
    .landing-content-area {
      width: 560px;
      height: 240px;
      .landing-content-subtitle p {
        font-size: 1em;
      }
      .landing-content-discription p {
        font-size: 0.8em;
      }
      .landing-content-discription-min p {
        display: none;
      }
    }
    .button-image {
      position: absolute;
      left: 96px;
      top: 192px;
      width: 400px;
    }
  }
  .section-fourth {
    .landing-content-discription {
      p {
        font-size: 0.8em;
      }
    }
    .landing-image-area {
      flex-direction: row;
      justify-content: space-between;
      .fourth-image {
        margin-top: 36px;
        width: 24vw;
        max-width: 260px;
      }
    }
  }
  .section-fifth {
    .landing-content-discription p {
      font-size: 0.8em;
    }
    .landing-content-discription-min p {
      display: none;
    }
    .about-us-team-image {
      width: 64vw;
      margin-top: 36px;
      min-width: 400px;
      max-width: 720px;
    }
    .about-us-team-image-min {
      display: none;
    }
    .about-us-team-text-min {
      display: none;
    }
  }
  .section-sixth {
    .landing-content-discription p {
      font-size: 0.8em;
      padding: 0 12px;
      display: block;
      color: #adc8d7;
      font-weight: 600;
    }
    .landing-content-discription-min p {
      display: none;
    }
    .sixth-link-area {
      width: 560px;
      height: 124px;
      flex-direction: row;
      text-align: left;
      .sixth-link-text-min {
        display: none;
      }
      .otran-button-goto {
        position: absolute;
        right: 0px;
        top: 40px;
      }
    }
    .landing-content-discription p {
      font-size: 0.8em;
    }
    .sixth-image-area {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      .sixth-image {
        .sixth-image-title {
          margin-top: 36px;
        }
      }
    }
  }
}
@media (min-width: 992px) {
  .section-first {
    flex-direction: row;
    .landing-content-area {
      width: 32vw;
      margin-right: 32px;
      .landing-content-discription {
        p {
          font-size: 0.9em;
        }
      }
    }
    .main-top {
      width: 66vw;
      max-width: 640px;
      z-index: 1;
    }
  }
  .section-second {
    .second-image {
      width: 72vw;
      margin-top: 36px;
      min-width: 400px;
      max-width: 880px;
    }
    .second-image-min {
      display: none;
    }
    .landing-content-discription {
      p {
        font-size: 0.9em;
      }
    }
  }
  .section-third {
    .landing-content-area {
      width: 560px;
      height: 240px;
      .landing-content-subtitle p {
        font-size: 1em;
      }
      .landing-content-discription {
        p {
          font-size: 0.9em;
        }
      }
      .landing-content-discription-min p {
        display: none;
      }
    }
    .button-image {
      position: absolute;
      left: 96px;
      top: 192px;
      width: 400px;
    }
  }
  .section-fourth {
    .landing-content-discription {
      p {
        font-size: 0.9em;
      }
    }
    .landing-image-area {
      flex-direction: row;
      justify-content: space-between;
      .fourth-image {
        margin-top: 36px;
        width: 24vw;
        max-width: 260px;
      }
    }
  }
  .section-fifth {
    .landing-content-discription p {
      font-size: 0.9em;
    }
    .landing-content-discription-min p {
      display: none;
    }
    .about-us-team-image {
      width: 64vw;
      margin-top: 36px;
      min-width: 400px;
      max-width: 720px;
    }
    .about-us-team-image-min {
      display: none;
    }
    .about-us-team-text-min {
      display: none;
    }
  }
  .section-sixth {
    .landing-content-discription p {
      font-size: 0.9em;
      padding: 0 12px;
      display: block;
      color: #adc8d7;
      font-weight: 600;
    }
    .landing-content-discription-min p {
      display: none;
    }
    .sixth-link-area {
      width: 560px;
      height: 124px;
      flex-direction: row;
      text-align: left;
      .sixth-link-text-min {
        display: none;
      }
      .otran-button-goto {
        position: absolute;
        right: 0px;
        top: 40px;
      }
    }
    .sixth-image-area {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      .sixth-image {
        .sixth-image-title {
          margin-top: 36px;
        }
      }
    }
  }
}

.landing {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  align-items: center;
  .landing-scene {
    display: block;
    max-width: 1200px;
    width: 100vw;
    margin: 0 auto;
    padding-bottom: 64px;
  }
}

.section-first {
  width: 80vw;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 76px;
  display: flex;
  justify-content: space-between;
  .landing-content-area {
    min-width: 205px;
    .landing-content-title {
      p {
        @include title;
        color: #8d0f28;
        margin-bottom: 0;
      }
    }
    .landing-content-subtitle {
      p {
        font-size: 1.1em;
        font-weight: 600;
        color: #5e5d5d;
        line-height: 2em;
        margin-bottom: 12px;
      }
    }
  }
}

.section-second {
  @include section;
  display: block;
  margin-top: 48px;
  text-align: center;
  background-color: white;
  .landing-content-area {
    .landing-content-title {
      p {
        @include title;
        color: #1f5595;
        margin-bottom: 16px;
      }
    }
  }
}

.section-third {
  @include section;
  padding-top: 10px;
  height: 424px;
  background: url('/img/landing/main-second-back.png');
  display: block;
  text-align: center;
  .landing-content-area {
    display: table;
    vertical-align: center;
    background: rgba(#e4f4fd, 0.6);
    margin: 0 auto;
    border-bottom-left-radius: 60px;
    border-bottom-right-radius: 60px;
    position: relative;

    .landing-content-title {
      p {
        @include title;
        color: #d34d41;
        margin-top: 36px;
      }
    }
    .landing-content-subtitle p {
      font-weight: 600;
      color: #d34d41;
      line-height: 2em;
      margin-bottom: 12px;
    }
    .landing-content-discription {
      p {
        font-size: 0.8em;
      }
    }
  }
}

.section-fourth {
  @include section;
  display: block;
  text-align: center;
  .landing-content-area {
    .landing-content-title {
      p {
        @include title;
        color: #1f5595;
        margin-bottom: 16px;
      }
    }
  }
  .landing-image-area {
    display: flex;
    margin: 0 auto;
    width: 64vw;
    max-width: 720px;
  }
}

.section-fifth {
  @include section;
  background-color: white;
  display: block;
  padding-bottom: 96px;
  text-align: center;
  .about-us-image {
    width: 120px;
    margin-bottom: 16px;
  }
}

.section-sixth {
  @include section;
  display: block;
  text-align: center;
  padding-bottom: 36px;
  background-color: #8d0f28;
  .sixth-link-area {
    margin: 0 auto;
    position: relative;
    top: -80px;
    background-color: #adc8d7;
    padding: 30px;
    border-radius: 12px;
    display: flex;
    .sixth-link-text p {
      font-size: 0.8em;
      color: #000000;
      margin-bottom: 4px;
    }
    .otran-button-goto {
      width: 124px;
    }
  }
  .landing-content-area {
    .landing-content-title {
      p {
        @include title;
        color: #adc8d7;
        margin-bottom: 8px;
      }
    }
  }
  .sixth-image-area {
    width: 80vw;
    margin: 0 auto;
    max-width: 720px;
    .sixth-image {
      background: url('/img/landing/main-third-item.svg');
      background-repeat: no-repeat;
      background-size: 232px;
      margin-top: 24px;
      width: 212px;
      height: 172px;
      .sixth-image-title {
        color: #e3c67a;
        font-size: 0.9em;
        font-weight: 600;
        margin-bottom: 12px;
        width: 232px;
      }
      .sixth-image-content {
        p {
          font-size: 0.8em;
          color: #ffffff;
          font-weight: 600;
          margin-bottom: 4px;
        }
      }
    }
  }
}
</style>
